import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Header } from '../header/header';
import { SideMenu } from '../side-menu/side-menu';
import { Button } from '../../ui/button/button';
import { AuthStore } from '../../auth/store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  imports: [MatSidenavModule, MatIconModule, MatButtonModule, Header, SideMenu, Button],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
})
export class Layout {
  protected readonly sideMenu = viewChild.required(SideMenu);
  readonly authStore = inject(AuthStore);
  readonly router = inject(Router);
  readonly user = computed(() => this.authStore.user());
  readonly rightActionButtonLabel = signal('Login/Create account');

  navigateToLoginScreen(): void {
    this.authStore.setLoginMode(true);
    this.router.navigate(['/login-page']);
  }

  navigateToCreateListing(): void {
    this.router.navigate(['/create-listing']);
  }
}
